import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-style-three',
  templateUrl: './courses-style-three.component.html',
  styleUrls: ['./courses-style-three.component.scss']
})
export class CoursesStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
